var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "action-notes" },
    [
      _c(
        "div",
        [
          _vm.newNoteType === "single-invoice"
            ? [
                _c("div", [
                  _c("h4", { staticClass: "mb-25" }, [
                    _vm._v(_vm._s(_vm.$t("makeNote")))
                  ])
                ]),
                _vm._v(" "),
                _c("new-note", {
                  attrs: {
                    type: "invoice",
                    "recipient-prop": _vm.recipient,
                    "legal-entity-prop": _vm.legalEntity,
                    single: true
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.newNoteType === "multi-invoice"
            ? [
                _c("div", [
                  _c("h4", { staticClass: "mb-25" }, [
                    _vm._v(_vm._s(_vm.$t("makeNote")))
                  ])
                ]),
                _vm._v(" "),
                _c("new-note", {
                  attrs: {
                    type: "invoice",
                    "recipient-prop": _vm.recipient,
                    "legal-entity-prop": _vm.legalEntity
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.newNoteType === "recipient"
            ? [
                _c("div", [
                  _c("h4", { staticClass: "mb-25" }, [
                    _vm._v(_vm._s(_vm.$t("makeNote")))
                  ])
                ]),
                _vm._v(" "),
                _c("new-note", {
                  attrs: {
                    type: "recipient",
                    "recipient-prop": _vm.recipient,
                    "legal-entity-prop": _vm.legalEntity
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "disp-flex filterLine" }, [
        _c("h4", [_vm._v(_vm._s(_vm.$t("latestActions")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-auto" },
          [
            _vm._v(_vm._s(_vm.$t("showSystemActions")) + " "),
            _c("el-switch", {
              model: {
                value: _vm.showSystemNotes,
                callback: function($$v) {
                  _vm.showSystemNotes = $$v
                },
                expression: "showSystemNotes"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "disp-flex filterLine" },
        [
          _c(
            "el-select",
            {
              attrs: {
                "collapse-tags": "",
                multiple: "",
                size: "mini",
                placeholder: _vm.$t("statusFilter")
              },
              model: {
                value: _vm.channelFilterSelection,
                callback: function($$v) {
                  _vm.channelFilterSelection = $$v
                },
                expression: "channelFilterSelection"
              }
            },
            _vm._l(_vm.CONSTANTS.ACTIONNOTES_TYPES, function(item) {
              return _c("el-option", {
                key: item,
                attrs: {
                  label: _vm.$translate.action_and_note(item),
                  value: item
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "LoadingButton",
            {
              attrs: {
                size: "mini",
                type: "primary",
                execute: _vm.applyFilters
              }
            },
            [_vm._v(_vm._s(_vm.$t("applyFilters")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "disp-flex filterLine" },
        [
          _c(
            "el-input",
            {
              attrs: { size: "mini", placeholder: "" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onSearch.apply(null, arguments)
                }
              },
              model: {
                value: _vm.searchTerm,
                callback: function($$v) {
                  _vm.searchTerm = $$v
                },
                expression: "searchTerm"
              }
            },
            [
              _c("i", {
                staticClass: "el-input__icon el-icon-search",
                attrs: { slot: "prefix" },
                slot: "prefix"
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "displ-flex mb-25" },
        _vm._l(_vm.selectedInvoices, function(invoice) {
          return _c(
            "el-tag",
            {
              key: invoice.reference,
              staticClass: "cursor-pointer mr-10 mb-10",
              attrs: { closable: true, size: "small", type: "info" },
              on: {
                close: function($event) {
                  return _vm.handleRemoveSelectedInvoice(invoice)
                }
              }
            },
            [_vm._v("\n\t\t\t" + _vm._s(invoice.document_number) + "\n\t\t")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.actionsNotes && _vm.actionsNotes.length >= 1
        ? [
            _vm.actionsNotes && _vm.actionsNotes.length > 0
              ? _c(
                  "timeline",
                  {
                    attrs: {
                      "show-load-more":
                        _vm.actionsNotes.length !== _vm.totalActionsNotes,
                      "timeline-items": _vm.actionsNotes
                    },
                    on: { loadMore: _vm.handleLoadMore }
                  },
                  _vm._l(_vm.actionsNotes, function(actionNote) {
                    return _c(
                      "el-timeline-item",
                      { key: actionNote.reference },
                      [_vm._v("\n\t\t\t\t" + _vm._s(actionNote) + "\n\t\t\t")]
                    )
                  }),
                  1
                )
              : _vm._e()
          ]
        : _vm.actionsNotes && _vm.actionsNotes.length === 0
        ? [_vm._v("\n\t\t" + _vm._s(_vm.$t("noData")) + "\n\t")]
        : [_vm._v("\n\t\t" + _vm._s(_vm.$t("loading")) + "\n\t")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }